<p-listbox  [options]="employees" 
            [style]="{width:'260px', height:'400px'}"
            class="p-inputtext-sm" 
            name="employee"
            appendTo="body"
            inputId="employee" 
            optionLabel="text"
            (onChange)="onChange($event)"
            [(ngModel)]="selectedEmployees"
            [checkbox]="true" 
            [filter]="true" 
            [multiple]="true" >
</p-listbox >

